import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { Routes, RouterModule } from '@angular/router';
//import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppComponent } from './app.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';


import { HeaderComponent } from './header/header.component';
//import { PreloaderComponent } from './preloader/preloader.component';
import { FooterComponent } from './footer/footer.component';

import { ResponseAddressLoaderComponent } from './components/response-address-loader/response-address-loader.component';
import { ResponseIndexLoaderComponent } from './components/response-index-loader/response-index-loader.component';

import { FindAddressComponent } from './pages/find-address/find-address.component';
import { FindPostIndexComponent } from './pages/find-post-index/find-post-index.component';

import { FormInputCityComponent } from './components/city-input/form-city-input.component';
import { FormCitySelectComponent } from './components/city-select/form-city-select.component';
import { StreetSelectComponent } from './components/street-select/street-select.component';
import { HouseSelectComponent } from './components/house-select/house-select.component';

import { SiteLogoComponent } from './svg/site-logo/site-logo.component';
import { SiteLogoWinterComponent } from './svg/site-logo-winter/site-logo-winter.component';
import { ProfileIconComponent } from './svg/profile-icon/profile-icon.component';
import { PostalMarketComponent } from './svg/postal-market/postal-market.component';
import { OwnMarkComponent } from './svg/brand-icons/own-mark/own-mark.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
//import { AngularFontAwesomeModule } from 'angular-font-awesome';
//import { NgbModule} from '@ng-bootstrap/ng-bootstrap';

import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { InfoComponent } from './pages/info/info.component';
import { DownloadButtonComponent } from './components/download-button/download-button.component';
import { MobileMenuComponent } from './components/mobile-menu/mobile-menu.component';
import { CookieMessageComponent } from './components/cookie-message/cookie-message.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';


import { ModalModule } from 'ngx-bootstrap/modal';
import { DownloadUpComponent } from './components/download-up/download-up.component';


const appRoutes: Routes = [
	{ path: '', redirectTo: 'find-post-index', pathMatch: 'full' },  // component: FindAddressComponent }, //
	//{ path: '/:city-name', redirectTo: 'find-address', pathMatch: 'full' },
	{ path: 'find-address', component: FindAddressComponent },
	{ path: 'find-post-index', component: FindPostIndexComponent },
	{ path: 'postcodes-and-offices', component: InfoComponent },
	{ path: '**', redirectTo: 'find-post-index' }, // component: FindPostIndexComponent }

];

@NgModule({
	declarations: [
		AppComponent,
		HeaderComponent,
		//PreloaderComponent,
		FooterComponent,
		FindAddressComponent,
		//FindPostCodeComponent,
		FindPostIndexComponent,
		SiteLogoComponent,
		ProfileIconComponent,
		PostalMarketComponent,
		OwnMarkComponent,
		ResponseAddressLoaderComponent,
		ResponseIndexLoaderComponent,
		FormInputCityComponent,
		FormCitySelectComponent,
		StreetSelectComponent,
		HouseSelectComponent,
		InfoComponent,
		DownloadButtonComponent,
		MobileMenuComponent,
		SiteLogoWinterComponent,
		CookieMessageComponent,
		DownloadUpComponent,
	],
  imports: [
		ModalModule.forRoot(),
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(appRoutes, {useHash: false}), // , {useHash: true}    , enableTracing: true
    BsDropdownModule.forRoot(),
    HttpClientModule,
    FormsModule,
    LeafletModule.forRoot(),
    //AngularFontAwesomeModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    //NgbModule,
  ],
	providers: [],
	bootstrap: [AppComponent]
})
export class AppModule { }
